<template>
  <template v-if="items.length">
    <div class="asset-stats-grid">
      <div
        v-for="item in items"
        :key="item.key"
        class="asset-stat"
      >
        <div class="asset-stat-header">
          <i class="bi bi-activity" />
          <span>{{ item.label }}</span>
        </div>
        <div class="asset-stat-value">
          {{ item.value }}
        </div>
      </div>
    </div>
  </template>
  <div
    v-else
    class="modbus-empty"
  >
    <i class="bi bi-plug" />
    <span>Brak danych modbus</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

type ParamConfig = { labelKey: string; unit: string; multiplier?: number }

const WAGO_PARAM_CONFIG: Record<string, ParamConfig> = {
  'WAGO_5002_VOLTAGE_L1':  { labelKey: 'components.assetDetails.modbusLabels.l1_voltage',      unit: 'V' },
  'WAGO_5004_VOLTAGE_L2':  { labelKey: 'components.assetDetails.modbusLabels.l2_voltage',      unit: 'V' },
  'WAGO_5006_VOLTAGE_L3':  { labelKey: 'components.assetDetails.modbusLabels.l3_voltage',      unit: 'V' },
  'WAGO_5032_VOLT_L1L2':   { labelKey: 'components.assetDetails.modbusLabels.l1_l2_voltage',   unit: 'V' },
  'WAGO_5036_VOLT_L2L3':   { labelKey: 'components.assetDetails.modbusLabels.l2_l3_voltage',   unit: 'V' },
  'WAGO_5034_VOLT_L1L3':   { labelKey: 'components.assetDetails.modbusLabels.l1_l3_voltage',   unit: 'V' },
  'WAGO_502C_PF_L1':       { labelKey: 'components.assetDetails.modbusLabels.l1_power_factor', unit: '' },
  'WAGO_502E_PF_L2':       { labelKey: 'components.assetDetails.modbusLabels.l2_power_factor', unit: '' },
  'WAGO_5030_PF_L3':       { labelKey: 'components.assetDetails.modbusLabels.l3_power_factor', unit: '' },
  'WAGO_5008_FREQUENCY':   { labelKey: 'components.assetDetails.modbusLabels.frequency',        unit: 'Hz' },
  'WAGO_5014_P_ACT_L1':    { labelKey: 'components.assetDetails.modbusLabels.l1_active_power', unit: 'W', multiplier: 1000 },
  'WAGO_5016_P_ACT_L2':    { labelKey: 'components.assetDetails.modbusLabels.l2_active_power', unit: 'W', multiplier: 1000 },
  'WAGO_5018_P_ACT_L3':    { labelKey: 'components.assetDetails.modbusLabels.l3_active_power', unit: 'W', multiplier: 1000 },
  'WAGO_500C_CURRENT_L1':  { labelKey: 'components.assetDetails.modbusLabels.l1_current',      unit: 'A' },
  'WAGO_500E_CURRENT_L2':  { labelKey: 'components.assetDetails.modbusLabels.l2_current',      unit: 'A' },
  'WAGO_5010_CURRENT_L3':  { labelKey: 'components.assetDetails.modbusLabels.l3_current',      unit: 'A' },
}

export default defineComponent({
  name: 'ModbusLatestParamsPanel',
  props: {
    latestParams: {
      type: Array,
      required: true
    }
  },
  computed: {
    items(): Array<{ key: string; label: string; value: string }> {
      const params = Array.isArray(this.latestParams) ? this.latestParams : []
      const seen = new Set<string>()
      return params
        .filter((param: any) => {
          const name = param?.can_params_io?.param_name
          if (!name || !WAGO_PARAM_CONFIG[name] || seen.has(name)) return false
          seen.add(name)
          return param?.value !== null && param?.value !== undefined
        })
        .map((param: any) => {
          const name: string = param.can_params_io.param_name
          const config = WAGO_PARAM_CONFIG[name]
          const raw = parseFloat(param.value)
          const numeric = Number.isFinite(raw) ? raw * (config.multiplier ?? 1) : null
          const formatted = numeric !== null ? numeric.toFixed(2) : '—'
          return {
            key: `${name}-${param?.id ?? ''}`,
            label: this.$t(config.labelKey) as string,
            value: config.unit ? `${formatted} ${config.unit}` : formatted
          }
        })
        .sort((a, b) => a.label.localeCompare(b.label))
    }
  }
})
</script>
